// Autenticación con Google (GIS). useLoadProfile() carga /auth/me UNA sola vez en la
// raíz; useAuth() solo LEE el estado (evita bucles de montaje).
import { useEffect } from 'react'
import { api } from '@/services/api'
import { useAuthStore } from '@/store/authStore'
import { tokenValid, initGoogleAuth, promptGoogle, googleSignOut } from '@/googleAuth'
import type { DataResponse, User } from '@/types'

export function useAuth() {
  const { user, isLoading } = useAuthStore()
  const setUser = useAuthStore((s) => s.setUser)

  const login = () => promptGoogle()
  const logout = () => {
    googleSignOut()
    setUser(null)
    window.location.assign('/login')
  }

  return { user, isLoading, isAuthenticated: tokenValid(), login, logout }
}

// Carga el perfil local desde /auth/me. Llamar UNA sola vez, en el root (App).
export function useLoadProfile() {
  const setUser = useAuthStore((s) => s.setUser)
  const setLoading = useAuthStore((s) => s.setLoading)

  useEffect(() => {
    initGoogleAuth().catch(() => {
      /* GIS best-effort: la pantalla de Login igual dibuja el botón */
    })
    if (!tokenValid()) {
      setUser(null)
      return
    }
    setLoading(true)
    api
      .get<DataResponse<User>>('/auth/me')
      .then((res) => setUser(res.data.data))
      .catch(() => setUser(null))
  }, [setUser, setLoading])
}
